import { InputAdornment, OutlinedInput } from "@mui/material";
import ListPageHeader, { ListPageHeaderGroupActions, ListPageHeaderRight } from "../../Misc/ListPageHeader";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../Redux/redux-store";
import {
  GetScale,
  GetScales,
  SetActiveScale,
  SetFilterText,
  SetScales,
} from "../../../Redux/Reducers/redux-slice-drive";
import { SearchOutlined } from "@mui/icons-material";
import ScaleSlider from "../../Misc/ScaleSlider";

export const DriveGridHeader = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [filterText, setFilterText] = useState();

  const folderHeaderRef = useRef<HTMLDivElement>(null);

  const scale = useAppSelector(GetScale);
  const scales = useAppSelector(GetScales);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((event) => {
      // recalculate scales to avoid very small asset cards
      // 6 colonnes = > 1000
      // 4 colonnes = >650
      // 3 colonnes = >500
      // 2 colonnes = >340
      if (event[0].contentBoxSize[0].inlineSize < 340) {
        if (scale === 2 || scale === 3 || scale === 4 || scale === 6) dispatch(SetActiveScale(12));
        dispatch(SetScales([12]));
      } else if (event[0].contentBoxSize[0].inlineSize < 500) {
        if (scale === 2 || scale === 3 || scale === 4) dispatch(SetActiveScale(6));
        dispatch(SetScales([6, 12]));
      } else if (event[0].contentBoxSize[0].inlineSize < 650) {
        if (scale === 2 || scale === 3) dispatch(SetActiveScale(4));
        dispatch(SetScales([4, 6, 12]));
      } else if (event[0].contentBoxSize[0].inlineSize < 1000) {
        if (scale === 2) dispatch(SetActiveScale(3));
        dispatch(SetScales([3, 4, 6, 12]));
      } else {
        dispatch(SetScales([2, 3, 4, 6, 12]));
      }
    });

    if (folderHeaderRef.current) resizeObserver.observe(folderHeaderRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <ListPageHeader
      sx={{
        px: 2,
        overflowY: "visible",
        py: 1.5,
        mb: 0,
        borderTop: "1px solid",
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
      ref={folderHeaderRef}
    >
      <ListPageHeaderGroupActions>
        <OutlinedInput
          label={t("field:label.filterEllipsis")}
          placeholder={t("field:label.filterEllipsis")}
          value={filterText}
          sx={(t) => ({
            width: "120px",
            "&.Mui-focused": { width: "220px" },
            transition: t.transitions.create(["width"], {
              easing: t.transitions.easing.sharp,
              duration: t.transitions.duration.enteringScreen,
            }),
          })}
          size="small"
          onChange={(value) => dispatch(SetFilterText(value.target.value))}
          endAdornment={
            <InputAdornment position="end">
              <SearchOutlined />
            </InputAdornment>
          }
        />
      </ListPageHeaderGroupActions>
      <ListPageHeaderRight>
        <ScaleSlider scales={scales} scale={scale} setScale={(scale) => dispatch(SetActiveScale(scale))} />
      </ListPageHeaderRight>
    </ListPageHeader>
  );
};
